import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n";
import { SiteProvider } from "@/lib/site";
import { initLenis } from "@/lib/lenis";
import ErrorBoundary from "@/lib/ErrorBoundary";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  useEffect(() => {
    const destroy = initLenis();
    return destroy;
  }, []);

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <SiteProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </BrowserRouter>
        </SiteProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
